<template>
  <div>
    <div class="card">
      <div class="card-header">
        <i class="fa fa-align-justify"></i>
        Karty lojalnościowe
      </div>
      <div class="card-actions">
        <a href class="btn btn-secondary btn-sm" @click.prevent="toggleFiltersVisibility()">
          <span v-if="filtersVisible">Ukryj filtry</span>
          <span v-if="!filtersVisible">Pokaż filtry</span>
        </a>
      </div>
      <div class="card-filters" v-if="filtersVisible">
        <form @submit.prevent="searchList()">
          <div class="row">
            <div class="form-group col-md-2">
              <label>Nazwisko</label>
              <input class="form-control" v-model="filters.qLastName" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Imiona</label>
              <input class="form-control" v-model="filters.qFirstName" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Pesel</label>
              <input class="form-control" v-model="filters.qPesel" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Numer karty</label>
              <input class="form-control" v-model="filters.qCardNumber" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Migracja</label>
              <input class="form-control" v-model="filters.qMigration" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Komentarz</label>
              <input class="form-control" v-model="filters.qComment" type="text"/>
            </div>
            <div class="form-group col-md-2">
              <label>Rodzaj karty</label>
              <select class="form-control" id="cardType" v-model="filters.qCardType">
                <option value=""></option>
                <option value="10">{{ $t('loyaltyCards.level.10')}}</option>
                <option value="20">{{ $t('loyaltyCards.level.20')}}</option>
                <option value="30">{{ $t('loyaltyCards.level.30')}}</option>
              </select>
            </div>
            <div class="form-group col-md-2">
              <label for="qStatus">Status</label>
              <select class="form-control" id="qStatus" v-model="filters.qStatus">
                <option value="active">Aktywna</option>
                <option value="archived">Zarchiwizowana</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12">
              <button type="submit" class="btn btn-primary">Szukaj</button>

              <button type="button" @click="clearFilters()" class="btn btn-link">Wyczyść filtry</button>
            </div>
          </div>
        </form>
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-bordered table-striped">
          <thead class="">
          <tr>
            <th scope="col" @click="setOrderBy('lastName')">{{ $t('clients.fullName') }}</th>
            <th scope="col">{{ $t('loyaltyCards.cardType') }}</th>
            <th scope="col" @click="setOrderBy('cardNumber')">{{ $t('loyaltyCards.cardNumber')}}</th>
            <th scope="col">{{ $t('clients.clientId') }}</th>
            <th scope="col">{{ $t('common.actions') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr class="loading" v-if="isLoading" v-bind:key="item"
              v-for="item in $store.state[paramsName].pageSize">
            <td v-bind:data-id="item"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr v-if="!totalCount && !isLoading">
            <td colspan="5">
              Brak rekordów spełniających podane kryteria.
              Zmień lub <a href @click.prevent="clearFilters()">wyczyść filtry</a>.
            </td>
          </tr>
          <tr v-for="loyaltyCard in loyaltyCards" v-if="!isLoading" :key="loyaltyCard.loyaltyId" class="client-row">
            <td>{{ loyaltyCard.fullName }}</td>
            <td>{{ $t('loyaltyCards.level.' + loyaltyCard.cardType)}}</td>
            <td>{{ loyaltyCard.cardNumber }}</td>
            <td>
              {{ loyaltyCard.clientId }}
              <span class="badge badge-danger mr-2" v-if="!loyaltyCard.clientId">Błąd migracji</span>
            </td>
            <td>
              <a href @click.prevent="goToDetails(loyaltyCard)">Szczegóły</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <list-pager
          v-bind:params-name="paramsName"
          v-bind:total-count="totalCount"
          @reload="loadItems()">
      </list-pager>
    </div>
  </div>

</template>

<script>
  import loyaltyCards from '@Service/loyaltyCards';
  import { toastError, listMixin } from '../helpers';
  import { router } from '@Router';
  import listPager from '@Component/list-pager';

  export default {
    data: function () {
      return {
        paramsName: 'loyaltyCardsParams',
        loyaltyCards: [],
        totalCount: 0,
        filters: {},
        filtersVisible: false,
        isLoading: false,
      };
    },
    mixins: [
      listMixin,
    ],
    components: {
      listPager,
    },
    methods: {
      goToDetails: (loyaltyCard) => {
        const { loyaltyId } = loyaltyCard;
        router.push({ name: 'loyaltyCardsDetails', params: { loyaltyId } });
      },
      loadItems: function () {
        this.isLoading = true;
        loyaltyCards.getLoyaltyCards(this.$store.state[this.paramsName])
          .then(response => {
            this.totalCount = parseInt(response.headers.get('totalCount'), 10);
            this.loyaltyCards = response.data;
          })
          .catch(toastError)
          .then(() => this.isLoading = false);
      },
      searchList: function () {
        this.$store.commit('setParams', {
          paramsName: this.paramsName,
          params: {
            ...this.filters,
            offset: 0,
          },
        });

        this.loadItems();
      },
      clearFilters: function () {
        this.filters = {
          qLastName: '',
          qFirstName: '',
          qPesel: '',
          qCardNumber: '',
          qCardType: '',
          qStatus: 'active',
          qComment: '',
          qMigration: '',
        };
        this.searchList();
      },
    },
    mounted: function () {
      this.filters = {
        qLastName: this.$store.state[this.paramsName].qLastName,
        qFirstName: this.$store.state[this.paramsName].qFirstName,
        qPesel: this.$store.state[this.paramsName].qPesel,
        qCardNumber: this.$store.state[this.paramsName].qCardNumber,
        qCardType: this.$store.state[this.paramsName].qCardType,
        qStatus: this.$store.state[this.paramsName].qStatus,
        qComment: this.$store.state[this.paramsName].qComment,
        qMigration: this.$store.state[this.paramsName].qMigration,
      };
      this.filtersVisible = this.$store.state[this.paramsName].filtersVisible;
      this.loadItems();
    },
  };
</script>
<style>

</style>